<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.1318 43.1707C41.3472 43.6066 52.8502 34.3684 52.5575 33.0854C52.1259 31.1934 41.9011 22.9629 40.8361 23.5553C39.8072 24.1277 40.7119 31.3099 40.6457 33.6744C40.5386 37.5016 39.6815 43.0091 40.1318 43.1707Z"
      fill="#C3D7D1"
    />
    <path
      d="M40.3043 31.5457C40.3043 31.5457 39.7094 24.6717 40.4073 24.6177C41.1319 24.5618 51.6576 32.6701 52.0051 33.7746C52.4396 35.1553 40.667 44.2244 39.971 43.0876C39.275 41.9509 41.4108 35.5217 39.7648 34.487C39.7648 34.487 27.2963 30.4228 14.8799 32.53"
      stroke="#020D03"
      stroke-width="1.33"
      stroke-linecap="round"
    />
  </svg>
</template>
